import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router'
import { alpha, Box, styled } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import DataIcon from 'assets/icons/icon-products-data-ok.svg?react'
import UploadIcon from 'assets/icons/icon-file-file-upload-white.svg?react'

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: '100%',
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,

  '& h4.MuiTypography-body2': {
    flex: '1 1 auto',
    maxWidth: theme.spacing(35)
  }
}))

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(5),
  height: theme.spacing(5),
  background: alpha(theme.palette.common.black, 0.05),
  borderRadius: '50%',
  marginBottom: theme.spacing(2),

  '& svg': {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25)
  }
}))

export function HomeOnboardingDataImport() {
  const navigate = useNavigate()

  const navigateToDataImport = () => {
    navigate('/data', { state: { import: true } })
  }

  return (
    <Root p={4}>
      <IconWrapper>
        <DataIcon />
      </IconWrapper>
      <Typography component="h3" variant="h6" mb={1.5}>
        <FormattedMessage id="home.onboarding.import.title" />
      </Typography>
      <Typography component="h4" variant="body2" color="textSecondary" mb={1.5}>
        <FormattedMessage id="home.onboarding.import.content" />
      </Typography>
      <Button color="primary" variant="outlined" onClick={navigateToDataImport} startIcon={<UploadIcon />}>
        <FormattedMessage id="home.onboarding.import.button" />
      </Button>
    </Root>
  )
}

export default HomeOnboardingDataImport
